import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'customerStatements',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    ChartComp: require('@/customcontrols/chart.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    MenuListItem: require('@/employee/enquiries/menuListItem.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      test: false,
      settingFor: 'customer',
      customerAllData: null,
      menuVisible: true,
      customerName: '',
      lang: '',

      property: null,
      readings: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "userReadingNo",
        isLoading: true,
      },
      readingGraph: {
        data: [],
        isLoading: true,
        arg_field: "rdgDate",
        value_field: "consumption",
      },
      consumption: {
        data: [],
        isLoading: true,
        arg_field: "rdgDate",
        value_field: "consumption",
      },
     
      lastInvoiveIssueDate: '',
      lastInvoiveIssueAmount: '',
      lastReadingDate: '',
      lastReading: '',

      propId: null,
      custkey: null,

      pagesLoaded: ['Readings', 'Consumption','ReadingGraph'],
    }
  },
  mounted() {
    this.goToDefaultTab(this.selectedTab);

    this.getCustomerDisplayInfo();
  },
  computed: {   
    isLoading: function () {
      return this.readings.isLoading;
    },
    showEmptyState: function () {
      if (!this.readings.data || this.readings.data.length == 0)
        return true;
      else
        return false;
    },
  },
  watch: {
    selectedTab: function (val) {
      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    }
  },
  methods: {
    init() {
      this.propId = this.$route.params.propertyId;
      this.custkey = this.$route.params.custkey;

      this.selectedTab = 'Readings';
      this.isReadingsExpanded = true;

      this.fillColumns();
      this.getProperties();

      this.getCustomerDisplayInfo();
    },
    fillColumns() {
      this.readings.cols.length = 0;

      this.readings.cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesAccount.meterRef') });
      this.readings.cols.push({ dataField: 'readingNoAbs', caption: this.$t('enquiriesAccount.no') });
      this.readings.cols.push({ dataField: 'rdgDate', caption: this.$t('enquiriesAccount.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.readings.cols.push({ dataField: 'noOfDays', caption: this.$t('enquiriesAccount.noOfDays') });
      this.readings.cols.push({ dataField: 'reading', caption: this.$t('enquiriesAccount.reading') });
      this.readings.cols.push({ dataField: 'calculatedConsumption', caption: this.$t('enquiriesAccount.calculatedConsumption') });
      this.readings.cols.push({ dataField: 'modifiedConsumption', caption: this.$t('enquiriesAccount.modifiedConsumption') });
      this.readings.cols.push({ dataField: 'diffFromMainConsumption', caption: this.$t('enquiriesAccount.diffFromMainConsumption') });
      this.readings.cols.push({ dataField: 'consumption', caption: this.$t('enquiriesAccount.totalConsumption') });
      this.readings.cols.push({ dataField: 'flow', caption: this.$t('enquiriesAccount.flow') });
      this.readings.cols.push({ dataField: 'clockOver', caption: this.$t('enquiriesAccount.clockOver') });
      this.readings.cols.push({ dataField: 'isCancelled', caption: this.$t('enquiriesAccount.cancelled') });
      this.readings.cols.push({ dataField: 'typeDescription', caption: this.$t('enquiriesAccount.type') });
      this.readings.cols.push({ dataField: 'reasonDescription', caption: this.$t('enquiriesAccount.reason') });
      this.readings.cols.push({ dataField: 'methodDescription', caption: this.$t('enquiriesAccount.readingMethod') });
      this.readings.cols.push({ dataField: 'noteCode', caption: this.$t('enquiriesAccount.note') });
      this.readings.cols.push({ dataField: 'accessCode', caption: this.$t('enquiriesAccount.access') });
      this.readings.cols.push({ dataField: 'comment', caption: this.$t('enquiriesAccount.comment') });
      this.readings.cols.push({ dataField: 'isInvoiced', caption: this.$t('enquiriesAccount.billed') });
      this.readings.cols.push({ dataField: 'invoiceDate', caption: this.$t('enquiriesAccount.billingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
    },
    getData() {
      this.getReadings(true);
      this.getReadingsGraph(true);
      this.getReadingsConsumption(true);
    },
    getProperties() {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.properties = response.data.items;
            if (response.data.items.length > 0) {
              this.property = response.data.items[0];
              this.propertyId = this.propId == -1 ? response.data.items[0].propertyId : this.propId;

              this.getData();
            }
          }
          else
            this.getDataFailed();
        })
        .catch(e => { this.getDataFailed(e) })
        .finally(() => {
          this.readings.isLoading = false;
        })
    },

    getReadings(loader = false) {
      this.readings.isLoading = loader;

      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: this.readings.pageingOption
      }

      axios.post('/Enquiries/getPropertyReadings', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            if (response.data.items && response.data.items.length > 0)
              response.data.items.forEach(i => i['readingNoAbs'] = Math.abs(i.readingNo));

            this.readings.data = response.data.items;

            this.readings.totalRow = response.data.itemsCount;

            this.getLastReadingData();
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        });
    },
    getLastReadingData() {
      this.lastReadingDate = this.readings.data.length == 0 ? '' : moment(this.readings.data[0].rdgDate).format('DD/MM/YYYY');

      this.lastReading = this.readings.data.length == 0 ? '' : this.readings.data[0].reading.toString();
    },

    getReadingsGraph(loader = false) {
      this.readingGraph.isLoading = loader;

      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getPropertyReadingsGraph', parameters)
        .then(response => {
          if (response.data.data.status == 0) {

            let _Readings = response.data.items;

            for (let i = 0; i < _Readings.length; i++) {
              this.readingGraph.data.push(
                {
                  MeterRef: _Readings[i].MeterRef,
                  consumption: _Readings[i].reading,
                  rdgDate: this.$options.filters.formatDateDDMMYYY(_Readings[i].rdgDate)
                }
              );
            }
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.readingGraph.isLoading = false);
    },
    getReadingsConsumption(loader = false) {
      this.consumption.isLoading = loader;

      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getPropertyReadingsConsumptions', parameters)
        .then(response => {
          if (response.data.data.status == 0) {

            let _Consumption = response.data.items;

            for (let i = 0; i < response.data.items.length; i++) {
              this.consumption.data.push({ MeterRef: _Consumption[i].meterRef, consumption: _Consumption[i].consumption, rdgDate: this.$options.filters.formatDateDDMMYYY(_Consumption[i].rdgDate) });
            }
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.consumption.isLoading = false);
    },
  },
}
